module.exports = __webpack_public_path__ + "media/images/common/ico-rank-4-02cc0773bb252d07db447932cb39d9df.svg";